import { setDefaultMainApplicantEmploymentIncomePeriod, setDefaultMainApplicantOtherIncomePeriod, setDefaultCoApplicantsEmploymentIncomePeriod, setDefaultCoApplicantsOtherIncomePeriod, setDefaultMainApplicantPreferredLanguage, setDefaultCoApplicantsPreferredLanguage, setDefaultCoApplicantsId, setDefaultMainApplicantNumChildren } from "@Shared/@Utils/application-defaults-utils/application-transform-functions";
import { runSafeApplicationTransform } from "@Shared/@Utils/application-defaults-utils/util-functions";
export default [{
  // set employment > income-period to "annual" when adding employments
  transform: runSafeApplicationTransform(setDefaultMainApplicantEmploymentIncomePeriod),
  rootPath: "main-applicant",
  paths: ["main-applicant[employment]"],
  triggerOnLoad: true,
  triggerOnAddition: true
}, {
  // set employment > income-period to "annual" when adding other incomes
  transform: runSafeApplicationTransform(setDefaultMainApplicantOtherIncomePeriod),
  rootPath: "main-applicant",
  paths: ["main-applicant[other-income]"],
  triggerOnAddition: true
}, {
  // set employment > income-period to "annual" when adding new co-applicants
  transform: runSafeApplicationTransform(setDefaultCoApplicantsEmploymentIncomePeriod),
  paths: ["co-applicants", "co-applicants[X][employment]", "co-applicants[X][employment][X]"],
  rootPath: "co-applicants",
  triggerOnLoad: true,
  triggerOnAddition: true
}, {
  // set co-applicants > other income > income-period to "annual" when adding other incomes
  transform: runSafeApplicationTransform(setDefaultCoApplicantsOtherIncomePeriod),
  rootPath: "co-applicants",
  paths: ["co-applicants[X][other-income]"],
  triggerOnAddition: true
}, {
  transform: runSafeApplicationTransform(setDefaultCoApplicantsPreferredLanguage,
  // set co-applicant > language-preference to main applicant language when adding new co-applicants
  setDefaultCoApplicantsId // set a default co applicant id
  ),
  rootPath: "co-applicants",
  paths: ["co-applicants"],
  triggerOnLoad: true,
  triggerOnAddition: true
}, {
  // set main-applicant > language-preference to "english"
  transform: runSafeApplicationTransform(setDefaultMainApplicantPreferredLanguage),
  rootPath: "main-applicant",
  triggerOnLoad: true
}, {
  // set main-applicant > personal-details > num-children to "0"
  transform: runSafeApplicationTransform(setDefaultMainApplicantNumChildren),
  rootPath: "main-applicant",
  triggerOnLoad: true
}];